import React from 'react';
import { connect } from 'react-redux';
import { forgotPassword, verifyOTP, closeModal, resendOTP, resetPassword } from '../../actions/changePasswordActions';
import { logFileCreation } from  '../../actions/commonActions';
import Modal from 'react-modal';
import { Button, Tabs, Tab } from 'react-bootstrap';
import '../../theme/styles/reactstrap.css';
import styles from './ForgotPassword.less';
import i18next from 'i18next';
import {
    loadCaptchaEngine,
    LoadCanvasTemplate,
    validateCaptcha,
    ReloadCaptcha
} from "./Captcha";
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
import MUIIcon from '../../components/IconMaterialUI/MUIIcon';

class ForgotPassword extends React.Component {
    state = {
        showUnknown:false,
        isVerifyActive:false,
        isChangePassActive:false,
        isDoneActive:false,
        username:'',
        captchaInput:'',
        companyCode:'',
        errorMessage:'',
        showError:false,
        showOTP:false,
        OTPCode:'',
        time:0,
        isCountdownCompleted:false,
        activeTab:1,
        newPassword:'',
        confirmPassword:'',
        showResend:false,
        isError:false
    }
    timer = 0;

    componentDidMount() {
        loadCaptchaEngine(6);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOTPSent !== prevProps.isOTPSent) {
            if (this.props.isOTPSent) {
                this.setState({
                    showOTP:this.props.isOTPSent,
                })

                // start timer for resend
                this.startTimer();
            }
        }
        if (this.props.isAuthenticated !== prevProps.isAuthenticated) {
            if (!this.props.isAuthenticated) {
                this.setState({
                    showError:true,
                    errorMessage:this.props.showTraderCode ? 'Invalid Username / Company Code' : 'Invalid Username'
                })
            }
        }
        if (this.props.statusCode !== prevProps.statusCode) {
            switch(this.props.statusCode) {
                case 0:
                    this.setState({
                        activeTab:3,
                        isDoneActive:true,
                        isChangePassActive:false,
                        isVerifyActive:false,
                    })
                    break;

                case 1:
                    this.setState({
                        showError:true,
                        errorMessage:'Password should be different from last 3 passwords.',
                    })
                    break;

                case 200:
                    this.setState({
                        showOTP:false,
                        OTPCode:'',
                        activeTab:2,
                        isChangePassActive:true,
                        isVerifyActive:false,
                        captchaInput:'',
                    }, () => {
                        this.props.closeModal();
                        this.resetTimer();
                    });
                    break;

                case 201:
                    this.setState({
                        errorMessage:'OTP resend failed.',
                        OTPCode:'',
                        isError:true
                    })
                    break;

                case 210:
                    this.setState({
                        errorMessage:'OTP has been sent to your registered e-mail address.',
                        OTPCode:'',
                        isError:false
                    })
                    break;

                case 220:
                    this.setState({
                        errorMessage:'Incorrect OTP. Please try again.',
                        OTPCode:'',
                        isError:true
                    });
                    break;

                case 221:
                    this.setState({
                        errorMessage: 'OTP Expired. Generate new OTP using Resend OTP.',
                        OTPCode: '',
                        isError: true
                    });
                    break;

                case null:
                    this.setState({showOTP:false, OTPCode:''});
                    break;

                default:
                    this.setState({
                        showError:true,
                        errorMessage:'Something went wrong. Please try again.',
                        OTPCode:'',
                    });
            }
        }
    }

    startTimer = () => {
        try{
            const millis = this.props.OTPResendExpiryTime ? this.props.OTPResendExpiryTime : 60000;
            this.setState({
                time:millis
            });
            if (this.timer === 0 && millis > 0) {
                this.timer = setInterval(this.countDown, 1000);
            }
        }catch(e){
            this.props.logFileCreation({error:e.message, originFunction:'startTimer', component:"ForgotPassword"});
        }
    }

    resetTimer = () => {
        try{
            clearInterval(this.timer);
            this.timer = 0;
            this.setState({
                isCountdownCompleted:true,
                showResend:true
            })
        }catch(e){
            this.props.logFileCreation({error:e.message, originFunction:'resetTimer', component:"ForgotPassword"});
        }
    }

    countDown = () => {
        try{
            const millis = this.state.time - 1000;
            this.setState({
                time:millis
            });
            if (millis === 0) {
                this.resetTimer()
            }
        }catch(e){
            this.props.logFileCreation({error:e.message, originFunction:'countDown', component:"ForgotPassword"});
        }
    };

    showTime = (time) => {
        try{
            const min = Math.floor(time / 60000);
            const minutes = min < 10 ? min.toString().padStart(2, '0') : min.toFixed();
            const sec = ((time % 60000) / 1000).toFixed(0);
            const seconds = sec < 10 ? sec.padStart(2, '0') : sec;
            return `${minutes}:${seconds}`;
        }catch(e){
            this.props.logFileCreation({error:e.message, originFunction:'showTime', component:"ForgotPassword"});
        }
    };

    mapCompanyToLocation = async (company) => {
        try{
            let locations = [];
            const env = this.props.configInfo && this.props.configInfo.isProd === false ? 'dev' : 'production';
            const response = await fetch(`https://neox-asset.neofinancials.com/ntp/${env}/properties/LocationMap.json`);
            if (response.ok) {
                locations = await response.json();
            }
            let locationCode = locations.filter(loc => loc.DESC === company)[0];
            if (locationCode) {
                locationCode = locationCode.CODE
            } else {
                locationCode = company
            }
            return locationCode;
        }catch(e){
            this.props.logFileCreation({error:e.message, originFunction:'mapCompanyToLocation', component:"ForgotPassword"});
        }
    }

    resetErrors = () => {
        try{
            this.setState({
                showError:false,
                errorMessage:'',
                OTPCode:'',
                showOTP:false,
                captchaInput: ''
            });
            this.props.closeModal();
            this.setState({
                showResend:false,
                isCountdownCompleted:false
            })

            // reset captcha
            loadCaptchaEngine(6);
        }catch(e){
            this.props.logFileCreation({error:e.message, originFunction:'resetErrors', component:"ForgotPassword"});
        }
    }

    handleSubmit = () => {
        try{
            // check for empty form values
            let error = '', isError = false;
            if (this.state.username === '') {
                error += `Username cannot be blank.\n`;
                isError = true;
            }
            if (this.state.companyCode === '' && this.props.showTraderCode) {
                error += `Company Code cannot be blank.\n`;
                isError = true;
            }
            if (this.state.captchaInput === '') {
                error += `Captcha cannot be blank.\n`;
                isError = true;
            } else if (!validateCaptcha(this.state.captchaInput)) {
                error += `Captcha does not match.\n`;
                isError = true;
            }
            this.setState({
                showError:isError,
                errorMessage:error
            })
            // api call
            if (isError) {
                return;
            } else {
                this.startTimer();
                // make api call and submit
                const formData = {};
                if (this.props.showTraderCode) {
                    this.mapCompanyToLocation(this.state.companyCode).then(code => {
                        formData['companyCode'] = code;
                        formData['traderCode'] = this.state.username;
                        this.props.forgotPassword(formData);
                    });
                } else {
                    formData['companyCode'] = this.props.defaultLocation;
                    formData['traderCode'] = this.state.username;
                    this.props.forgotPassword(formData);
                }
            }
        }catch(e){
            this.props.logFileCreation({error:e.message, originFunction:'handleSubmit', component:"ForgotPassword"});
        }
    }

    handleOTP = () => {
        try{
            // check for empty form values
            let error = '', isError = false;
            if (this.state.OTPCode === null || this.state.OTPCode === '') {
                error = 'OTP cannot be blank.';
                isError = true;
            }
            if (error !== '') {
                this.setState({
                    isError:true,
                    errorMessage:error
                })
            }

            // api call
            if (isError) {
                return;
            } else {
                // make api call and submit
                let formData = {};
                formData['traderCode'] = this.state.username;
                formData['OTP'] = this.state.OTPCode;

                if (this.props.showTraderCode) {
                    this.mapCompanyToLocation(this.state.companyCode).then(code => {
                        formData['companyCode'] = code;
                        this.props.verifyOTP(formData);
                    });
                } else {
                    formData['companyCode'] = this.props.defaultLocation;
                    this.props.verifyOTP(formData);
                }
            }
        }catch(e){
            this.props.logFileCreation({error:e.message, originFunction:'handleOTP', component:"ForgotPassword"});
        }
    }

    handleResend = () => {
        try{
            this.startTimer();
            this.setState({
                isCountdownCompleted:false
            })

            // make api call and submit
            const formData = {};
            if (this.props.showTraderCode) {
                this.mapCompanyToLocation(this.state.companyCode).then(code => {
                    formData['companyCode'] = code;
                    formData['traderCode'] = this.state.username;
                    this.props.resendOTP(formData);
                });
            } else {
                formData['companyCode'] = this.props.defaultLocation;
                formData['traderCode'] = this.state.username;
                this.props.resendOTP(formData);
            }
        }catch(e){
            this.props.logFileCreation({error:e.message, originFunction:'handleResend', component:"ForgotPassword"});
        }
    }

    handleOTPInput = (e) => {
        try{
            // handled this way instead of type=number to block values with 'e'
            const numberOnly = /^[0-9\b]+$/;
            const otp = e.currentTarget.value.trim();
            if (otp === '' || numberOnly.test(otp)) {
                this.setState({OTPCode:otp});
            }
        }catch(e){
            this.props.logFileCreation({error:e.message, originFunction:'handleOTPInput', component:"ForgotPassword"});
        }
    }

    handleReset = () => {
        try{
            // check for empty form values
            let error = '', isError = false;

            if (this.state.newPassword === '') {
                error += `New Password cannot be blank.\n`;
                isError = true;
            } else if (!this.state.newPassword.match(/^(?=.*[A-Za-z&@!#$])(?=.*\d)[A-Za-z&@!#$\d]{8,16}$/)) {
                error += `New Password should be 8-16 characters long. It must be alphanumeric and can contain special characters such as &@!#$.\n`;
                isError = true;
            }
            if (this.state.confirmPassword === '') {
                error += `Confirm Password cannot be blank.\n`;
                isError = true;
            } else if (!this.state.confirmPassword.match(/^(?=.*[A-Za-z&@!#$])(?=.*\d)[A-Za-z&@!#$\d]{8,16}$/)) {
                error += `Confirm Password should be 8-16 characters long. It must be alphanumeric and can contain special characters such as &@!#$.\n`;
                isError = true;
            } else if (this.state.newPassword !== this.state.confirmPassword) {
                error += 'New Password and Confirm Password do not match.';
                isError = true;
            }
            this.setState({
                showError:isError,
                errorMessage:error
            })

            // api call
            if (isError) {
                return;
            } else {
                // make api call and submit
                let formData = {};
                formData['traderCode'] = this.state.username;
                formData['password'] = this.state.newPassword;

                if (this.props.showTraderCode) {
                    formData['companyCode'] = this.mapCompanyToLocation(this.state.companyCode);
                } else {
                    formData['companyCode'] = this.props.defaultLocation;
                }
                this.props.resetPassword(formData);
            }
        }catch(e){
            this.props.logFileCreation({error:e.message, originFunction:'handleReset', component:"ForgotPassword"});
        }
    }

    renderReload = (<MUIIconWithTooltip icon={'Refresh'} className={`${styles.icon}`} title={i18next.t("refresh")} />);
    render() {
        const unknownMessage = this.props.showTraderCode ? 'Unknown Username / Company Code' : 'Unknown Username';

        return (
            <div>
                <Modal isOpen={this.state.showUnknown} className={`${styles.modal} ${styles.errorModal}`}>
                    <div className={styles.mdlWrap}>
                        <div className={styles.modalHeader}>
                            <span>{unknownMessage}</span>
                            <span onClick={() => this.setState({showUnknown:false})} className={styles.closeIcon}>
                                <MUIIcon icon={'Close'} className="closeBtn"/>
                            </span>
                        </div>

                        <div className="msg commonMsgDir">
                            <p className={styles.txt}>Please contact the Trading Desk for your login credentials.</p>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={this.state.showError} className={`${styles.modal} ${styles.errorModal}`}>
                    <div className="fpmdlWrap">
                        <div className={styles.modalHeader}>
                            <span>Error</span>
                            <span onClick={this.resetErrors} className={styles.closeIcon}>
                                <MUIIcon icon={'Close'} className="closeBtn"/>
                            </span>
                        </div>

                        <div className="msg commonMsgDir">
                            {this.state.errorMessage.split('\n').map(message => (
                                <p className={styles.txt}>{message}</p>
                            ))}
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={this.state.showOTP} className={`${styles.modal} ${styles.codeModal}`}>
                    <div className={styles.mdlWrap}>
                        <div className={styles.modalHeader}>
                            <span>Input One Time Password</span>
                            <span onClick={this.resetErrors} className={styles.closeIcon}>
                                <MUIIcon icon={'Close'} className="closeBtn"/>
                            </span>
                        </div>

                        <div className="msg commonMsgDir">
                            <p className={styles.txt}>Please enter the One Time Password that has been sent to your registered e-mail address.</p>

                            <div className="form-group row justify-content-end">
                                <div className="col-auto pr-3">
                                    <div className="form-inline">
                                        <label className={styles.label}>One Time Password</label>
                                        <input id="secCode"
                                            className={styles.otpInput}
                                            value={this.state.OTPCode}
                                            onChange={this.handleOTPInput}
                                            maxLength={6}
                                            autoFocus
                                        />
                                    </div>
                                </div>

                                <div className="col-5 mt-1 pl-0">
                                    {(this.state.showResend && this.state.isCountdownCompleted) && <a onClick={this.handleResend} className={`${styles.link} ${styles.resendLink}`}>Resend OTP</a>}
                                    {(this.state.showResend && !this.state.isCountdownCompleted) && <div className={styles.resendTimer}>Resend OTP in {this.showTime(this.state.time)}</div>}
                                </div>

                                <div className="col-12">
                                    {this.state.errorMessage !== '' ?
                                        <p className={this.state.isError ? styles.errMsg : styles.successMsg}>{this.state.errorMessage}</p>
                                    :
                                        <p className={`${styles.txt} ${styles.successMsg}`}>&nbsp;</p>
                                    }
                                </div>
                            </div>

                            <div className="row justify-content-center pt-4">
                                <div className="col-auto pl-0">
                                    <Button id="proceedBtn" className={styles.submitBtn} onClick={this.handleOTP}>Proceed</Button>
                                </div>
                            </div>

                            <p className={`${styles.txt} ${styles.smlTxt}`}>Kindly contact the Trading Desk if you have not received the One Time Password even after {this.props.OTPExpiryTime / 60000} {this.props.OTPExpiryTime >= 60000 ? 'minutes' : 'seconds'}.</p>
                        </div>
                    </div>
                </Modal>


                <div className={styles.resetPwdSection}>
                    <div className={styles.header}>
                        <h4>Reset Password</h4>
                    </div>

                    <div className={styles.resetPwdTabs}>
                        <Tabs
                            id="resetPwdTabs"
                            className="header_tabs"
                            activeKey={this.state.activeTab}
                            onSelect={(key) => this.setState({ activeTab:key})}
                        >
                            <Tab disabled={!this.state.isVerifyActive} eventKey={1} title="Verify Username">
                                <div>
                                    <div className="row">
                                        <div className="col-sm-4 p-1 text-right">
                                            <label className={styles.label}>Username</label>
                                        </div>
                                        <div className="col-sm-6 p-1">
                                            <input type="text"
                                                className={styles.otpInput}
                                                value={this.state.username}
                                                onChange={(e) => this.setState({username:e.currentTarget.value.trim()})}
                                                autoComplete="username"
                                            />
                                        </div>
                                    </div>

                                    {this.props.showTraderCode &&
                                        <div className="row">
                                            <div className="col-sm-4 p-1 text-right">
                                                <label className={styles.label}>Company Code</label>
                                            </div>
                                            <div className="col-sm-6 p-1">
                                                <input type="text"
                                                    className={`${styles.uCase} ${styles.otpInput}`}
                                                    value={this.state.companyCode}
                                                    onChange={(e) => this.setState({companyCode:e.currentTarget.value.trim().toUpperCase()})}
                                                    autoComplete="company-code"
                                                />
                                            </div>
                                        </div>
                                    }

                                    <div className="row">
                                        <div className="col-sm-4 p-1 text-right">
                                            <label className={styles.label}>Captcha</label>
                                        </div>
                                        <div className="col-sm-6 p-1">
                                            <input type="text" className={styles.otpInput} value={this.state.captchaInput} onChange={(e) => this.setState({captchaInput:e.currentTarget.value.trim()})} />
                                        </div>
                                    </div>

                                    <div className="row justify-content-end mt-3">
                                        <div className="col-sm-5 p-0">
                                            <div className={styles.captchaBlock}>
                                                <LoadCanvasTemplate showReload={false} />
                                            </div>
                                        </div>
                                        <div className="col-sm-3 text-left p-0">
                                            <ReloadCaptcha reload={this.renderReload} />
                                        </div>
                                    </div>

                                    <div className="row justify-content-center mt-5">
                                        <div className="col-auto">
                                            <Button className={styles.submitBtn} onClick={this.handleSubmit}>Next</Button>
                                        </div>
                                        <div className="col-auto">
                                            <Button className={styles.closeBtn} onClick={this.props.onClose}>Close</Button>
                                        </div>
                                    </div>

                                    <div className="row justify-content-center mt-4">
                                        <div className="col-auto text-center">
                                            <a className={styles.link} onClick={() => this.setState({showUnknown:true})}>{unknownMessage}</a>
                                        </div>
                                    </div>
                                </div>
                            </Tab>


                            <Tab disabled={!this.state.isChangePassActive} eventKey={2} title="Change Password">
                                <div>
                                    <div className="row">
                                        <div className="col-sm-4 p-1 text-right">
                                            <label className={styles.label}>Username</label>
                                        </div>
                                        <div className="col-sm-6 p-1">
                                            <input
                                                type="text"
                                                id="usernameDisabled"
                                                className={styles.otpInput}
                                                value={this.state.username}
                                                onChange={(e) => this.setState({username:e.currentTarget.value.trim()})}
                                                disabled
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-4 p-1 text-right">
                                            <label className={styles.label}>New Password</label>
                                        </div>
                                        <div className="col-sm-6 p-1">
                                            <input
                                                type="password"
                                                id="newPwd"
                                                className={styles.otpInput}
                                                autoComplete='new-password'
                                                value={this.state.newPassword}
                                                onChange={(e) => this.setState({newPassword:e.currentTarget.value.trim()})}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-4 p-1 text-right">
                                            <label className={styles.label}>Confirm Password</label>
                                        </div>
                                        <div className="col-sm-6 p-1">
                                            <input
                                                type="password"
                                                id="cnfrmPwd"
                                                className={styles.otpInput}
                                                autoComplete='off'
                                                value={this.state.confirmPassword}
                                                onChange={(e) => this.setState({confirmPassword:e.currentTarget.value.trim()})}
                                            />
                                        </div>
                                    </div>

                                    <div className="row justify-content-center mt-5">
                                        <div className="col-auto">
                                            <Button onClick={this.handleReset} className={styles.submitBtn}>Apply</Button>
                                        </div>
                                        <div className="col-auto">
                                            <Button className={styles.closeBtn} onClick={this.props.onClose}>Close</Button>
                                        </div>
                                    </div>
                                </div>
                            </Tab>


                            <Tab disabled={!this.state.isDoneActive} eventKey={3} title="Done">
                                <div>
                                    <p className={`${styles.txt} ${styles.doneTxt}`}>Your password has been changed successfully.<br />
                                    Click <a className={styles.link} onClick={this.props.onClose}>here</a> to log in with the new password.</p>

                                    <div className="row justify-content-center mt-5">
                                        <div className="col-auto">
                                            <Button className={styles.closeBtn} onClick={this.props.onClose}>Close</Button>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    showTraderCode:state.auth.configInfo.showTrdCompanyCode,
    isOTPSent:state.dashboardRoot.changePasswordReducer.isOTPSent,
    OTPExpiryTime:state.dashboardRoot.changePasswordReducer.OTPExpiryTime,
    OTPResendExpiryTime:state.dashboardRoot.changePasswordReducer.OTPResendExpiryTime,
    isOTPResent:state.dashboardRoot.changePasswordReducer.isOTPResent,
    isAuthenticated:state.dashboardRoot.changePasswordReducer.isAuthenticated,
    defaultLocation:state.auth.configInfo.location,
    statusCode:state.dashboardRoot.changePasswordReducer.OTPStatusCode,
    isOTPVerified:state.dashboardRoot.changePasswordReducer.isOTPVerified,
    configInfo: state.auth.configInfo
})

export default connect(mapStateToProps, {
    forgotPassword,
    verifyOTP,
    closeModal,
    resendOTP,
    resetPassword,
    logFileCreation
})(ForgotPassword);
